/**
 * @generated SignedSource<<1b59822ae538c210d621fbac81d90f2c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ProductCreateDialog_productPriceQuery$variables = {
  discountPrice: number;
  price: number;
  storeStuff: string;
};
export type ProductCreateDialog_productPriceQuery$data = {
  readonly productPrice: {
    readonly discountPercentage: number;
    readonly monthlyPrice: number;
  };
};
export type ProductCreateDialog_productPriceQuery = {
  response: ProductCreateDialog_productPriceQuery$data;
  variables: ProductCreateDialog_productPriceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "discountPrice"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "price"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeStuff"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "discountPrice",
        "variableName": "discountPrice"
      },
      {
        "kind": "Variable",
        "name": "price",
        "variableName": "price"
      },
      {
        "kind": "Variable",
        "name": "storeStuff",
        "variableName": "storeStuff"
      }
    ],
    "concreteType": "ProductPrice",
    "kind": "LinkedField",
    "name": "productPrice",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "discountPercentage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "monthlyPrice",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductCreateDialog_productPriceQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductCreateDialog_productPriceQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5133e5a36148c8a9c23b76178c7efae5",
    "id": null,
    "metadata": {},
    "name": "ProductCreateDialog_productPriceQuery",
    "operationKind": "query",
    "text": "query ProductCreateDialog_productPriceQuery(\n  $discountPrice: Int!\n  $price: Int!\n  $storeStuff: ID!\n) {\n  productPrice(discountPrice: $discountPrice, price: $price, storeStuff: $storeStuff) {\n    discountPercentage\n    monthlyPrice\n  }\n}\n"
  }
};
})();

(node as any).hash = "1112c0a3ccc07f139ece2bac2fe2f210";

export default node;
